module.exports = __webpack_public_path__ + "static/media/salesforce.3e1e7a05.svg";